import React from "react";

import {
  TableHeader,
  TableItemWrapper,
  TableWrapper,
} from "@/features/common/components/Table/Layout";
import TextPlaceholder from "@/features/placeholder/TextPlaceholder";

const TableHeaderPlaceholder = () => {
  return (
    <TableHeader className="grid-cols-12">
      <div className="md:col-span-4 flex items-center">
        <TextPlaceholder className="w-1/4" />
      </div>
      <div className="md:col-span-8 flex items-center">
        <TextPlaceholder className="w-2/4" />
      </div>
    </TableHeader>
  );
};

const TableContentPlaceholder = () => {
  return (
    <TableItemWrapper className="grid-cols-12">
      <div className="flex items-center col-span-full md:col-span-4">
        <div className="flex w-full space-x-2 items-center">
          <span className="block w-[50px] h-[50px] animate-pulse bg-gray-200 rounded-full" />

          <TextPlaceholder className="flex-1" size="sm" />
        </div>
      </div>

      <div className="flex items-center col-span-full md:col-span-8">
        <TextPlaceholder className="flex-1" size="sm" />
      </div>
    </TableItemWrapper>
  );
};

export const TablePlaceholder: React.FC = () => {
  return (
    <TableWrapper header={<TableHeaderPlaceholder />}>
      {new Array(6).fill(0).map((_, idx) => {
        return <TableContentPlaceholder key={idx} />;
      })}
    </TableWrapper>
  );
};
